module.exports = __webpack_public_path__ + "static/media/screenshot_history.cc72de8b.png";